// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable no-console */
/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */

import React, { useEffect, useRef, useState } from 'react';
import { Button, Card, Input, message, Modal, Space, Breadcrumb, Empty, Badge } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { ReloadOutlined, CheckOutlined, CloseOutlined, EyeOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import {
	getPendingDrivers,
	reviewDriverApplication,
	getDriverById,
	batchReviewDriverApplications,
} from '../../redux/driverSlice';
import { style } from '../../Styles';
import CustomAvatar from '../Global/CustomAvatar/CustomAvatar';
import ImageComponent from '../Global/ImageComponent/ImageComponent';
import DriverDetailsDrawer from './DriverDetailsDrawer';
import { downloadImage } from '../../redux/fileSlice';
import CustomTableComponentsPageable from '../Global/CustomTableComponentsPageable';

const { TextArea } = Input;

const PendingDriversComponent = ({ isActive }) => {
	const dispatch = useDispatch();
	const [currentPage, setCurrentPage] = useState(1);
	const [pageSize, setPageSize] = useState(10);
	const [isMakingApiCall, setMakingApiCall] = useState(true);
	const { PendingDrivers } = useSelector((state) => state.drivers);

	const [search, setSearch] = useState('');
	const searchTimerRef = useRef(null);
	const [sortBy, setSortBy] = useState('created');
	const [sortDirection, setSortDirection] = useState('DESC');
	const [selectedRowKeys, setSelectedRowKeys] = useState([]);
	const [batchReviewModal, setBatchReviewModal] = useState({
		visible: false,
		action: null,
		comments: '',
		submitting: false,
	});

	const handleTableChange = (_, __, sorter, extra) => {
		if (extra?.action !== 'sort') return;
		if (sorter.order) {
			setSortBy(sorter.columnKey || sorter.field || 'created');
			setSortDirection(sorter.order === 'ascend' ? 'ASC' : 'DESC');
		} else {
			setSortBy('created');
			setSortDirection('DESC');
		}
		setCurrentPage(1);
	};
	const [reviewModal, setReviewModal] = useState({
		visible: false,
		driver: null,
		action: null,
		comments: '',
		submitting: false,
	});

	const [drawerOpen, setDrawerOpen] = useState(false);
	const [selectedDriver, setSelectedDriver] = useState(null);

	const handleBatchAction = (action) => {
		if (selectedRowKeys.length === 0) {
			message.warning('Please select drivers to perform batch action');
			return;
		}
		setBatchReviewModal({
			visible: true,
			action,
			comments: '',
			submitting: false,
		});
	};
	const handleBatchSubmit = async () => {
		if (selectedRowKeys.length === 0 || !batchReviewModal.action) return;

		setBatchReviewModal((prev) => ({ ...prev, submitting: true }));

		try {
			const reviewData = {
				approved: batchReviewModal.action === 'approve',
				comments: batchReviewModal.comments || null,
			};

			await dispatch(
				batchReviewDriverApplications({
					driverIds: selectedRowKeys,
					reviewData,
				}),
			).unwrap();

			message.success(
				`${selectedRowKeys.length} driver(s) ${
					batchReviewModal.action === 'approve' ? 'approved' : 'rejected'
				} successfully`,
			);

			setBatchReviewModal({
				visible: false,
				action: null,
				comments: '',
				submitting: false,
			});

			setSelectedRowKeys([]);

			// Refresh the pending drivers list
			fetchPendingDrivers();
		} catch (error) {
			message.error(`Failed to ${batchReviewModal.action} drivers: ${error.message}`);
			setBatchReviewModal((prev) => ({ ...prev, submitting: false }));
		}
	};
	const columns = [
		{
			title: 'Profile Picture',
			key: 'profilePicture',
			render: (record) => {
				return record.profilePicture ? (
					<ImageComponent size={40} imageId={record?.profilePicture} />
				) : (
					<CustomAvatar name={`${record.name} ${record.surname}`} type='initials' />
				);
			},
			width: 90,
			show: true,
		},
		{
			title: 'Name',
			key: 'name',
			render: (record) => {
				return <span>{`${record.name} ${record.surname}`}</span>;
			},
			sorter: true,
			sortDirections: ['ascend', 'descend'],
			show: true,
		},
		{
			title: 'Email',
			dataIndex: 'email',
			key: 'email',
			sorter: true,
			sortDirections: ['ascend', 'descend'],
			show: true,
		},
		{
			title: 'Gender',
			dataIndex: 'gender',
			show: true,
		},
		{
			title: 'Phone',
			key: 'phone',
			render: (record) => {
				const fullPhone = record.phoneCountryCode
					? `+${record.phoneCountryCode} ${record.phone}`
					: record.phone;
				return <span>{fullPhone || 'N/A'}</span>;
			},
			sorter: true,
			sortDirections: ['ascend', 'descend'],
			show: true,
		},
		{
			title: 'Registration Date',
			key: 'created',
			render: (record) => {
				return record?.created ? dayjs(record?.created).format('DD/MM/YYYY') : 'N/A';
			},
			sorter: true,
			sortDirections: ['ascend', 'descend'],
			show: true,
		},
		{
			title: 'Application Status',
			key: 'applicationStatus',
			render: (record) => {
				const getStatusBadge = (status) => {
					switch (status) {
						case 'APPROVED':
							return (
								<Badge
									color='#52c41a'
									text={
										<span style={{ color: '#389e0d', fontWeight: 'bold' }}>
											APPROVED
										</span>
									}
								/>
							);
						case 'DENIED_RENEWAL':
							return (
								<Badge
									color='#ff4d4f'
									text={
										<span style={{ color: '#cf1322', fontWeight: 'bold' }}>
											DENIED RENEWAL
										</span>
									}
								/>
							);
						case 'DENIED':
							return (
								<Badge
									color='#ff4d4f'
									text={
										<span style={{ color: '#cf1322', fontWeight: 'bold' }}>
											DENIED
										</span>
									}
								/>
							);
						case 'PENDING':
							return (
								<Badge
									color='#d9d9d9'
									text={
										<span style={{ color: '#d9d9d9', fontWeight: 'bold' }}>
											PENDING
										</span>
									}
								/>
							);
						case 'PENDING_DOCUMENT_RENEWAL':
							return (
								<Badge
									color='#faad14'
									text={
										<span style={{ color: '#d46b08', fontWeight: 'bold' }}>
											PENDING DOCUMENT RENEWAL
										</span>
									}
								/>
							);
						default:
							return <span style={{ color: '#8c8c8c', fontWeight: 'bold' }}>_</span>;
					}
				};
				const driverApplicationStatus =
					record.taxiModeWithRole?.find((r) => r.role === 'DRIVER')?.applicationStatus ||
					null;
				return getStatusBadge(driverApplicationStatus);
			},
			sorter: {
				compare: (a, b) => {
					const statusA =
						a.taxiModeWithRole?.find((r) => r.role === 'DRIVER')?.applicationStatus ||
						'';
					const statusB =
						b.taxiModeWithRole?.find((r) => r.role === 'DRIVER')?.applicationStatus ||
						'';
					return statusA.localeCompare(statusB);
				},
				multiple: 1,
			},
			show: true,
		},
		{
			title: 'Actions',
			key: 'actions',
			render: (record) => {
				return (
					<Space>
						<Button
							type='primary'
							icon={<CheckOutlined />}
							size='small'
							onClick={() => handleReviewClick(record, true)}
							style={{ backgroundColor: '#52c41a', borderColor: '#52c41a' }}>
							Approve
						</Button>
						<Button
							type='primary'
							danger
							icon={<CloseOutlined />}
							size='small'
							onClick={() => handleReviewClick(record, false)}>
							Deny
						</Button>
						<Button
							type='default'
							icon={<EyeOutlined />}
							size='small'
							onClick={() => handleOpenDrawer(record)}>
							View
						</Button>
					</Space>
				);
			},
			show: true,
		},
	];

	const fetchPendingDrivers = () => {
		setMakingApiCall(true);
		dispatch(
			getPendingDrivers({
				page: currentPage - 1,
				size: pageSize,
				search,
				sortBy,
				sortDirection,
			}),
		)
			.unwrap()
			.then(() => {
				setMakingApiCall(false);
			})
			.catch(() => {
				setMakingApiCall(false);
				message.error('Failed to fetch pending drivers');
			});
	};

	const handleReviewClick = (driver, approved) => {
		setReviewModal({
			visible: true,
			driver,
			action: approved,
			comments: '',
			submitting: false,
		});
	};

	const handleOpenDrawer = (driver) => {
		setDrawerOpen(true);
		dispatch(getDriverById({ driverId: driver.id }))
			.unwrap()
			.then((freshDriver) => {
				setSelectedDriver(freshDriver);
			})
			.catch(() => {
				setSelectedDriver(driver);
			});
	};

	const handleCloseDrawer = () => {
		setDrawerOpen(false);
		setSelectedDriver(null);
	};

	const handleViewDocument = async (documentId, fileName, isPreview = false) => {
		try {
			const response = await dispatch(downloadImage(documentId)).unwrap();

			if (isPreview) {
				// Create a blob URL for preview
				const blob = new Blob([response], { type: 'application/octet-stream' });
				const url = window.URL.createObjectURL(blob);
				return url; // Return the URL for preview
			}

			// Original download behavior
			const blob = new Blob([response], { type: 'application/octet-stream' });
			const url = window.URL.createObjectURL(blob);
			const link = document.createElement('a');
			link.href = url;
			link.download = fileName || 'document';
			link.target = '_blank';
			link.click();
			window.URL.revokeObjectURL(url);
			return null;
		} catch (error) {
			message.error('Failed to download document');
			return null;
		}
	};

	// Function to check if any driver documents are expired
	const hasExpiredDocuments = (driver) => {
		const today = dayjs();

		// Get expiry dates from driverDocuments array
		const driverDocuments = driver.driverDocuments || [];
		const expiryDates = driverDocuments.map((doc) => doc.expiryDate).filter(Boolean);

		const hasExpired = expiryDates.some((date) => {
			const expiryDate = dayjs(date);
			const isExpired = expiryDate.isBefore(today, 'day');
			return isExpired;
		});

		return hasExpired;
	};

	const handleReviewSubmit = async () => {
		// Validate required comments for denials
		if (!reviewModal.action && (!reviewModal.comments || reviewModal.comments.trim() === '')) {
			message.error('Comments are required when denying a driver application');
			return;
		}

		// If approving a driver, check for expired documents
		if (reviewModal.action && hasExpiredDocuments(reviewModal.driver)) {
			message.error(
				'Cannot approve driver. One or more documents have expired. Please ensure all documents are up to date before approving the driver.',
			);
			return;
		}

		setReviewModal((prev) => ({ ...prev, submitting: true }));
		try {
			const reviewData = {
				approved: reviewModal.action,
				comments: reviewModal.comments || undefined,
			};

			await dispatch(
				reviewDriverApplication({
					driverId: reviewModal.driver.id,
					reviewData,
				}),
			).unwrap();

			const actionText = reviewModal.action ? 'approved' : 'denied';
			const driverName = `${reviewModal.driver.name} ${reviewModal.driver.surname}`;

			message.success({
				content: `Driver ${driverName} has been ${actionText} successfully`,
				duration: 5,
			});

			// Close modal
			setReviewModal({
				visible: false,
				driver: null,
				action: null,
				comments: '',
				submitting: false,
			});
		} catch (error) {
			const errorMessage = error?.message || 'Failed to review driver application';
			message.error({
				content: errorMessage,
				duration: 5,
			});
		} finally {
			setReviewModal((prev) => ({ ...prev, submitting: false }));
		}
	};

	const handleReviewCancel = () => {
		setReviewModal({
			visible: false,
			driver: null,
			action: null,
			comments: '',
			submitting: false,
		});
	};

	useEffect(() => {
		if (isActive) {
			fetchPendingDrivers();
		}
	}, [isActive, currentPage, pageSize, search, sortBy, sortDirection]);

	const driversArray = (PendingDrivers.driversList || []).map((driver) => ({
		...driver,
		key: driver.id,
	}));

	return (
		<div>
			<Card bordered={false} style={style.cardStyle}>
				<div style={style.inlineContent}>
					<div
						style={{
							display: 'flex',
							alignContent: 'center',
							alignItems: 'center',
							float: 'left',
							marginBottom: 8,
						}}>
						<Breadcrumb
							style={{ margin: '0 3em 0 0', fontSize: '1.1em' }}
							items={[
								{
									title: 'Pending Drivers',
								},
							]}
						/>
					</div>
					<div
						style={{
							...style.inlineContent,
							float: 'right',
							marginBottom: 8,
						}}>
						<Input.Search
							placeholder='Search drivers...'
							style={{ width: 250, marginRight: 8 }}
							allowClear
							onSearch={(val) => {
								if (searchTimerRef.current) clearTimeout(searchTimerRef.current);
								setCurrentPage(1);
								setSearch(val);
							}}
							onChange={(e) => {
								const val = e.target.value;
								if (searchTimerRef.current) clearTimeout(searchTimerRef.current);
								searchTimerRef.current = setTimeout(() => {
									setCurrentPage(1);
									setSearch(val);
								}, 400);
							}}
						/>
						<Button
							type='primary'
							icon={<ReloadOutlined />}
							onClick={fetchPendingDrivers}
							loading={isMakingApiCall}>
							Refresh
						</Button>
					</div>
				</div>
				{selectedRowKeys.length > 0 && (
					<div
						style={{
							marginBottom: 16,
							padding: '12px',
							backgroundColor: '#f5f5f5',
							borderRadius: '4px',
						}}>
						<Space>
							<span>
								<strong>{selectedRowKeys.length}</strong> driver(s) selected
							</span>
							<Button
								type='primary'
								icon={<CheckOutlined />}
								onClick={() => handleBatchAction('approve')}
								size='small'>
								Approve
							</Button>
							<Button
								danger
								icon={<CloseOutlined />}
								onClick={() => handleBatchAction('reject')}
								size='small'>
								Deny
							</Button>
							<Button
								type='default'
								onClick={() => setSelectedRowKeys([])}
								size='small'>
								Clear
							</Button>
						</Space>
					</div>
				)}

				{!isMakingApiCall && driversArray.length === 0 ? (
					<Empty
						description='No Driver Applications Pending'
						style={{ padding: '40px 0' }}
					/>
				) : (
					<CustomTableComponentsPageable
						isMakingApiCall={isMakingApiCall}
						columns={columns}
						dataArray={driversArray}
						handleSelectedRow={() => {}}
						handleDoubleClickRow={handleOpenDrawer}
						onTableChange={handleTableChange}
						rowSelection={{
							selectedRowKeys,
							onChange: setSelectedRowKeys,
							type: 'checkbox',
						}}
						pagination={{
							current: currentPage,
							pageSize,
							total: PendingDrivers.total || 0,
							onChange: (page, size) => {
								setCurrentPage(page);
								setPageSize(size);
							},
						}}
					/>
				)}
			</Card>

			{/* Review Modal */}
			<Modal
				title={
					reviewModal.action === null
						? 'Driver Application Details'
						: `${reviewModal.action ? 'Approve' : 'Deny'} Driver Application`
				}
				open={reviewModal.visible}
				onOk={reviewModal.action === null ? handleReviewCancel : handleReviewSubmit}
				onCancel={handleReviewCancel}
				confirmLoading={reviewModal.submitting}
				okText={
					reviewModal.action === null
						? 'Close'
						: reviewModal.action
						? 'Approve Driver'
						: 'Deny Driver'
				}
				okButtonProps={{
					type:
						reviewModal.action === null
							? 'default'
							: reviewModal.action
							? 'primary'
							: 'default',
					danger: reviewModal.action === false,
					size: 'large',
				}}
				cancelText={reviewModal.action === null ? null : 'Cancel'}
				cancelButtonProps={{ size: 'large' }}
				width={600}>
				{reviewModal.driver && (
					<div>
						{/* Action Summary - only show for approve/deny actions */}
						{reviewModal.action !== null && (
							<div
								style={{
									marginBottom: 20,
									padding: 16,
									backgroundColor: reviewModal.action ? '#f6ffed' : '#fff2f0',
									border: `1px solid ${
										reviewModal.action ? '#b7eb8f' : '#ffccc7'
									}`,
									borderRadius: 6,
								}}>
								<h4
									style={{
										color: reviewModal.action ? '#52c41a' : '#ff4d4f',
										marginBottom: 8,
									}}>
									{reviewModal.action ? '✓ Approve Driver' : '✗ Deny Driver'}
								</h4>
								<p style={{ margin: 0, fontSize: '14px' }}>
									{reviewModal.action
										? 'This driver will be approved and can start accepting rides.'
										: 'This driver will be denied and notified of the decision.'}
								</p>
							</div>
						)}

						<div style={{ marginBottom: 16 }}>
							<h4>Driver Information:</h4>
							<p>
								<strong>Name:</strong>{' '}
								{`${reviewModal.driver.name} ${reviewModal.driver.surname}`}
							</p>
							<p>
								<strong>Email:</strong> {reviewModal.driver.email}
							</p>
							<p>
								<strong>Phone:</strong>{' '}
								{reviewModal.driver.phoneCountryCode
									? `${reviewModal.driver.phoneCountryCode} ${reviewModal.driver.phone}`
									: reviewModal.driver.phone}
							</p>
							<p>
								<strong>Registration Date:</strong>{' '}
								{reviewModal.driver.created
									? new Date(reviewModal.driver.created).toLocaleString()
									: 'N/A'}
							</p>
						</div>

						{/* Comments section - only show for approve/deny actions */}
						{reviewModal.action !== null && (
							<div>
								<div style={{ marginBottom: 8, fontWeight: 'bold' }}>
									{reviewModal.action ? 'Approval' : 'Denial'} Comments{' '}
									{!reviewModal.action && '(Required)'}:
								</div>
								<TextArea
									rows={4}
									value={reviewModal.comments}
									onChange={(e) =>
										setReviewModal((prev) => ({
											...prev,
											comments: e.target.value,
										}))
									}
									placeholder={`Add comments for this ${
										reviewModal.action ? 'approval' : 'denial'
									}... ${!reviewModal.action ? '(Required for denials)' : ''}`}
									style={{ marginTop: 8 }}
									required={!reviewModal.action}
								/>
								{!reviewModal.action && (
									<div
										style={{
											marginTop: 8,
											fontSize: '12px',
											color: '#ff4d4f',
										}}>
										* Comments are required when denying a driver application
									</div>
								)}
							</div>
						)}

						{/* Action buttons for view mode */}
						{reviewModal.action === null && (
							<div style={{ marginTop: 20, textAlign: 'center' }}>
								<Space size='large'>
									<Button
										type='primary'
										icon={<CheckOutlined />}
										size='large'
										onClick={() =>
											setReviewModal((prev) => ({ ...prev, action: true }))
										}
										style={{
											backgroundColor: '#52c41a',
											borderColor: '#52c41a',
										}}>
										Approve Driver
									</Button>
									<Button
										type='primary'
										danger
										icon={<CloseOutlined />}
										size='large'
										onClick={() =>
											setReviewModal((prev) => ({ ...prev, action: false }))
										}>
										Deny Driver
									</Button>
								</Space>
							</div>
						)}
					</div>
				)}
			</Modal>
			{/* Batch Review Modal */}
			<Modal
				title={`Batch ${
					batchReviewModal.action === 'approve' ? 'Approve' : 'Deny'
				} Driver Applications`}
				open={batchReviewModal.visible}
				onOk={handleBatchSubmit}
				onCancel={() =>
					setBatchReviewModal({
						visible: false,
						action: null,
						comments: '',
						submitting: false,
					})
				}
				confirmLoading={batchReviewModal.submitting}
				okText={`${batchReviewModal.action === 'approve' ? 'Approve' : 'Deny'} ${
					selectedRowKeys.length
				} Driver(s)`}
				okButtonProps={{
					danger: batchReviewModal.action === 'reject',
					type: batchReviewModal.action === 'approve' ? 'primary' : 'default',
				}}>
				<div style={{ marginBottom: 16 }}>
					<strong>Selected Drivers:</strong> {selectedRowKeys.length} driver(s)
				</div>
				<div style={{ marginBottom: 16 }}>
					<label>
						<strong>
							Comments{' '}
							{batchReviewModal.action === 'reject' ? '(Required)' : '(Optional)'}:
						</strong>
					</label>
					<TextArea
						rows={4}
						value={batchReviewModal.comments}
						onChange={(e) =>
							setBatchReviewModal((prev) => ({ ...prev, comments: e.target.value }))
						}
						placeholder={`Add comments for batch ${
							batchReviewModal.action === 'approve' ? 'approval' : 'rejection'
						}...`}
						required={batchReviewModal.action === 'reject'}
					/>
				</div>
			</Modal>

			{/* Pending Driver Details Drawer */}
			<DriverDetailsDrawer
				open={drawerOpen}
				onClose={handleCloseDrawer}
				driver={selectedDriver}
				onApprove={(driver) => handleReviewClick(driver, true)}
				onDeny={(driver) => handleReviewClick(driver, false)}
				onViewDocument={handleViewDocument}
			/>
		</div>
	);
};

export default PendingDriversComponent;
